import { CATEGORIES } from "@/lib/constants";

export const CategoryFilterBar = ({ activeCategory, onCategoryChange, className = "" }) => {
  return (
    <div className={`${className}`}>
      <div className="flex gap-2 pb-1 flex-nowrap lg:flex-wrap overflow-x-auto lg:overflow-x-visible -mx-4 px-4 lg:mx-0 lg:px-0">
        <button onClick={() => onCategoryChange(null)} data-testid="category-filter-all"
          className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all duration-200 flex-shrink-0 ${!activeCategory ? 'bg-jeekota-primary text-white shadow-sm' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
          All
        </button>
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => onCategoryChange(cat)}
            data-testid={`category-filter-${cat.toLowerCase().replace(/\s+/g, '-')}`}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all duration-200 flex-shrink-0 ${activeCategory === cat ? 'bg-jeekota-primary text-white shadow-sm' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
            {cat}
          </button>
        ))}
      </div>
    </div>
  );
};
